import React from 'react';

import { Box, Heading, Text, ButtonPrimary } from '@primer/components'
import { withRouter } from "react-router-dom";

import WaveHero from './WaveHero'
import CodeReview from './BeforeAfter/BeforeAfterHorizontal'
import Clients from './Clients'
import useScreen from '../hooks/useScreen'


export default withRouter(function(props) {
  const { isSmall } = useScreen()
  const examplesCodes = isSmall ? props.examplesCodes.slice(0, 2) : props.examplesCodes
  const style = isSmall ? {} : {maxHeight: 450, overflowY: 'scroll'}
  return (
    <WaveHero>
      <Box className="container-lg pt-md-8 mb-10 col-md-6 pl-md-0 pr-md-0 pl-0 pr-0">
        <Box className="text-white m-md-0 text-center">
          <Heading as="h1" fontSize={58} paddingTop="15px" className="mb-4" lineHeight={"1em"}>{props.headline}</Heading>
          <Text
            as="p"
            className="lead text-white pl-2 pr-2 pl-md-0 pl-md-0"
          >{props.synopsis}</Text>
        </Box>
        { 
          examplesCodes && (
            <Box className="mt-2 mt-md-4" style={style}>
              <CodeReview examplesCodes={examplesCodes} />
            </Box>
          )
        }
        <Clients />
        
        <Box className="position-relative mt-6">
          <Text as="h3" className="text-center">
            <a href={props.linkUrl} className="text-white">
              <ButtonPrimary variant="large" className="f3 p-3">{props.linkText}</ButtonPrimary>
            </a>
          </Text>
        </Box>

      </Box>
    </WaveHero>
  )
})


